import { APIs, API_BASE_URL } from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";

export const getPacsQueueList = async (body) => {
  try {
    const response = await axiosInterceptor.post(APIs.PACSQUEUELIST, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const refreshQueueItem = async (id) => {
  try {
    const body = {
      id: id,
    };
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.REFRESHQUEUEITEM, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const cancelQueueItem = async (id) => {
  try {
    const body = {
      id: id,
    };
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.CANCELQUEUEITEM, { 
      data: body,
     });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const swapQueueItemPriority = async (queueItemId, direction) => {
  try {
    const body = {
      id: queueItemId,
      direction: direction,
    }; 
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.SWAPQUEUEPRIORITY, { 
      data: body,
     });
    return response;
  } catch (error) {
    return error.response;
  }
};